//Theme and Language
export const DEFAULT_LOCALE = "en";
// export const INTL_LANGUAGES = { en: "English", ka: "Kannada" };
export const INTL_LANGUAGES = { en: "English" };
export const DEFAULT_THEME = "blue";

//Token Expiry
export const TOKEN_EXPIRY_BUFFER_TIME = 600; //minutes
export const REFRESH_TOKEN_TIME = 585; //(60 * 9) + 45 -> 9hrs 45mins

export const AWS_BUCKET_URL =
  "https://edubricz-demo-images.s3.ap-south-1.amazonaws.com/";

const SUPER_ADMIN_ID = 1;
const ADMIN_ID = 2;
const TEACHER_ID = 6;
export const ADMIN_IDS = [SUPER_ADMIN_ID, ADMIN_ID];

export const menuImgType = "png";
export const minDate = new Date("01:01:1900");
export const maxDate = new Date("01:01:2100");


export const maxFileSize = {
  //size in bytes
  img: { size: 9000000, errorText: "Max Image size is 9MB" },
  file: { size: 10000000, errorText: "Max file size is 10MB" },
  video: { size: 100000000, errorText: "Max file size is 100MB" },
};

export const minDateValue = new Date('01:01:1900');
export const maxDateValue = new Date('01:01:2100');

export const DEFAULT_PAGINATION_PROPS_ID_LIST = {
  rowsPerPage: 10,
  page: 0,
  sortOrder: { name: 'id', direction: 'desc' }
}

//Material ui table options
export const options = {
  filterType: "dropdown",
  responsive: "standard",
  filter: false,
  download: false,
  print: false,
  viewColumns: false,
  rowsPerPageOptions: [5, 10, 15, 50, 100],
  rowsPerPage: 10,
  selectableRows: "none",
};
